<template>
  <!--Header Banner Form Content Start-->
  <div class="col-md-4 col-sm-5">
    <div class="trip-outer">
      <div class="trip-type-tabs">
        <ul class="nav nav-tabs">
          <li class="active">
            <a href="#one-way" data-toggle="tab">One Way</a>
          </li>
          <li>
            <a href="#two-way" data-toggle="tab">Two Way</a>
          </li>
        </ul>
      </div>

      <!--Banner Tab Content Start-->
      <div class="tab-content">
        <div class="tab-pane active" id="one-way">
          <bookingOneWay/>
        </div>
        <div class="tab-pane" id="two-way">
          <bookingTwoWay/>
          <!--Banner Form Content Start-->

          <!-- <form method="POST">
            <div class="trip-type-frm">
              <div class="field-outer">
                <span class="fas fa-user"></span>
                <input type="text" name="name" placeholder="Name" />
              </div>
              <div class="field-outer">
                <span class="fas fa-phone"></span>
                <input type="text" name="phoneNumber" placeholder="Phone Number" />
              </div>
              <div class="field-outer">
                <span class="fas fa-envelope"></span>
                <input type="text" name="email" placeholder="Email" />
              </div>
              <div class="field-outer">
                <span class="fas fa-search"></span>
                <input type="text" name="pick_loc" placeholder="Pickup Location" />
              </div>
              <div class="field-outer">
                <span class="fas fa-search"></span>
                <input type="text" name="drop_loc" placeholder="Drop Location" />
              </div>
              <div class="field-outer">
                <span class="fas fa-retweet"></span>
                <input type="text" name="return_loc" placeholder="Return Location" />
              </div>
              <div class="field-outer">
                <span class="fas fa-car"></span>
                <select name="drop_loc">
                  <option>Select Car Type</option>
                  <option
                    :value="vehicleType.id"
                    v-for="(vehicleType,key) in vehicleTypes"
                    :key="key"
                  >{{vehicleType.title}}</option>
                </select>
              </div>
            </div>
            <div class="date-time-picker{">
              <VueCtkDateTimePicker v-model="yourValue" label="Select PickUp Date" />
            </div>
            <div class="trip-type-frm">
              <div class="field-outer">
                <input type="checkbox" name="promo_code" id="promo_code" />
                <label for="promo_code">I Have Promotional Code</label>
              </div>
              <button type="submit" class="search-btn">
                Book Now
                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </button>
            </div>
          </form> -->
          <!--Banner Form Content End-->
        </div>
      </div>
      <!--Banner Tab Content End-->
    </div>
  </div>
  <!--Header Banner Form Content End-->
</template>
<script>

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import bookingOneWay from "./bookingOneWay";
import bookingTwoWay from "./bookingTwoWay";
export default {
  components: { VueCtkDateTimePicker ,bookingOneWay,bookingTwoWay},
  data() {
    return {
      yourValue: new Date(),
      
    };
  },
 
};
</script>
<style scoped>

</style>